export const firebaseConfig = {
  apiKey: "AIzaSyAHwRxNaWXOFGjK8oXLN4A8ygZQTJJ14g0",
  authDomain: "o-gacha-maker.firebaseapp.com",
  databaseURL: "https://o-gacha-maker.firebaseio.com",
  projectId: "o-gacha-maker",
  storageBucket: "o-gacha-maker.appspot.com",
  messagingSenderId: "530874723544",
  appId: "1:530874723544:web:da774eb06188d3f0f2bbad",
  measurementId: "G-P01Y7NJXS2"
};
// export const firebaseConfig = {
//   apiKey: "AIzaSyBm9mHuFVFYpoDgx5fFMlQ8N-N-qIx84a8",
//   authDomain: "canvasmaker-b1361.firebaseapp.com",
//   databaseURL: "https://canvasmaker-b1361.firebaseio.com",
//   projectId: "canvasmaker-b1361",
//   storageBucket: "canvasmaker-b1361.appspot.com",
//   messagingSenderId: "432838367085",
//   appId: "1:432838367085:web:e640c58aeebbf6309fac64",
//   measurementId: "G-FHZXVDFRPT"
// };
